
import { productQueries } from '../../data/products';
import { Product } from '../types';
import { logger } from '../../infrastructure/logger';

export interface SocialProofEvent {
    id: number;
    user: string;
    location: string;
    action: 'compró' | 'está mirando' | 'agregó al carrito';
    productName: string;
    productImage: string;
    timeAgo: string;
    productId: string;
}

const TUCUMAN_LOCATIONS = [
    'Yerba Buena', 'Barrio Norte', 'Tafí Viejo', 'Concepción', 'Banda del Río Salí', 
    'Lomas de Tafí', 'San Miguel', 'Barrio Sur', 'Manantial', 'Alderetes'
];

const NAMES = [
    'Facu', 'Milly', 'La Turca', 'Juancito', 'Agustina', 'El Deca', 
    'Santi', 'Mica', 'Rodri', 'Cami', 'Nico', 'Flor'
];

// Local cache to avoid repeated Firestore reads
let productsCache: Product[] = [];

export const activityService = {
    /**
     * Subscribes to a stream of "real-time" activities.
     */
    subscribeToActivity(callback: (event: SocialProofEvent) => void, minSecs: number = 8, maxSecs: number = 18): () => void {
        let timeoutId: number | null = null;
        let isSubscribed = true;

        const generateEvent = async () => {
            if (!isSubscribed) return;

            try {
                // Fetch products ONLY if cache is empty
                if (productsCache.length === 0) {
                    const { products } = await productQueries.getAllProducts(null, 50);
                    productsCache = products;
                }
                
                if (productsCache.length === 0) return;

                const randomProduct = productsCache[Math.floor(Math.random() * productsCache.length)];
                const randomUser = NAMES[Math.floor(Math.random() * NAMES.length)];
                const randomLoc = TUCUMAN_LOCATIONS[Math.floor(Math.random() * TUCUMAN_LOCATIONS.length)];
                const actions: ('compró' | 'está mirando' | 'agregó al carrito')[] = ['compró', 'está mirando', 'agregó al carrito'];
                const randomAction = actions[Math.floor(Math.random() * actions.length)];

                const event: SocialProofEvent = {
                    id: Date.now(),
                    user: randomUser,
                    location: randomLoc,
                    action: randomAction,
                    productName: randomProduct.title,
                    productImage: randomProduct.imageUrl,
                    timeAgo: 'hace instantes',
                    productId: randomProduct.id
                };

                callback(event);
            } catch (error) {
                logger.error('[ActivityService] Error generating social proof', error);
            }

            // Schedule next event (Custom interval)
            const nextTime = Math.floor(Math.random() * (maxSecs * 1000 - minSecs * 1000 + 1) + minSecs * 1000);
            timeoutId = window.setTimeout(generateEvent, nextTime);
        };

        // Initial delay
        const initialDelay = Math.floor(Math.random() * (5000 - 2000 + 1) + 2000);
        timeoutId = window.setTimeout(generateEvent, initialDelay);

        // Return unsubscribe function
        return () => {
            isSubscribed = false;
            if (timeoutId) clearTimeout(timeoutId);
        };
    }
};
